exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redirectLinkComponent-redirectLink{text-decoration:none}.redirectLinkComponent-linkText{font-family:'Lato-Regular', sans-serif;color:var(--text)}\n", ""]);

// exports
